export function generateFilename(clientName) {
  const date = new Date().toISOString().slice(0, 10);
  const safe = (clientName || 'client').replace(/[^a-z0-9]/gi, '_');
  return `${safe}_SEO_Report_${date}.pdf`;
}

export function buildCompetitorData(rankings) {
  const counts = {};
  (rankings || []).forEach(r => {
    (r.competitors || []).forEach(domain => {
      if (domain) counts[domain] = (counts[domain] || 0) + 1;
    });
  });
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 8)
    .map(([domain, count]) => ({ domain, count }));
}

export function getSummaryStats(rankings) {
  return (rankings || []).reduce((acc, r) => {
    if (r.rank === null || r.rank === undefined) acc.notRanked++;
    else if (r.rank <= 3) acc.top3++;
    else if (r.rank <= 10) acc.page1++;
    else acc.page2++;
    return acc;
  }, { top3: 0, page1: 0, page2: 0, notRanked: 0 });
}
